export default "__VITE_ASSET__C2IYl9d7__"